<template>
<div>
  <div ref="nav" class="search__component" :style="{'padding-bottom': fixed ? '20px' : 0}">
    <div class="search__component-block">
      <div class="location__block">
        <location @change="onLocationChangeFn"></location>
      </div>
      <div class="search__block" :class="{ focused: inputIsFocus }">
        <input type="text" placeholder="搜索课程关键字或老师" autocomplete="off" class="search__input" ref="searchInput"
          v-model.trim="searchWord" @focus="onInputFocusFn" @blur="onInputBlurFn"
          @keyup.enter="onEnterSearchFn" @input="onInputSearchFn"/>
        <div class="search__icon" @click="clickSearchBtn"></div>
        <div class="search__words" v-show="!inputIsFocus && !searchWord">
          <div class="item" v-for="(item, i) of hotwordsList" :key="i"  @click="toSearchPage(item)">{{ item }}</div>
        </div>
        <transition name="drop">
          <div class="search__list" v-show="inputIsFocus">
            <div class="search__list-block">
              <div class="query__list" v-if="querySugList.length">
                <div class="query__item" v-for="(item, i) of querySugList" :key="i"
                v-html="formatQueryItemFn(item)" @click="toSearchPage(item)"></div>
              </div>
              <template v-else>
                <div class="search__hotwords" v-if="searchHotwordsList.length">
                  <div class="title">热门搜索</div>
                  <div class="item" v-for="(item, i) of searchHotwordsList" :key="i" @click="toSearchPage(item)">
                    <span class="tag" :class="[ i < 3 ? `tag__${i+1}` : 'tag__gay' ]">{{ i + 1 }}</span>
                    <span>{{ item }}</span>
                  </div>
                </div>
                <div class="search__history" v-if="searchHistoryList.length">
                  <div class="history__header">
                    <div class="title">搜索历史</div>
                    <div class="clear" @click="clearHistoryFn">全部删除</div>
                  </div>
                  <div class="item" v-for="(item, i) of searchHistoryList" :key="i" @click="toSearchPage(item)">{{ item }}</div>
                </div>
              </template>
            </div>
          </div>
        </transition>
      </div>
      <div v-if="recommendQuery && recommendQuery.length" class="recommend-query">
        <span class="recommend-query__word" v-for="(item, index) in recommendQuery" :key="index">{{item}}</span>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import location from './components/location'
import axios from 'axios'
import jsCookie from 'js-cookie'
import xss from 'xss'
import { Base64 } from 'js-base64'
import scrollFixed from './scrollFixed.js'

export default {
  components: {
    location,
  },
  props: {
    fixed: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      hotwordsList: [],
      searchHotwordsList: [],
      searchWord: '',
      inputIsFocus: false,
      searchHistoryList: [],
      querySugList: [],
      recommendQuery: []
    }
  },
  mounted () {
    const keyword = xss(this.$route.query.keyword)
    if (keyword) {
      this.searchWord = keyword
    }

    if (this.fixed) { 
      this.scrollFixed({
        el:this.$refs.nav,
        top:94,
        zIndex:999
      })
    }
    this.requestSearchHotwordsDataFn()
    this.requestRecommendQueryFn()
  },
  watch: {
    $route() {
      this.requestRecommendQueryFn()
    }
  },
  methods: {
    scrollFixed,
    async requestSearchHotwordsDataFn () {
      const { switch_grade = -1, switch_subject = -1 } = this.$route.query
      try {
        const { data: res } = await axios.get('https://online.xueersi.com/mall/getHotWord', {
          params: {
            type: 2,
            switch_grade,
            switch_subject
          }
        })
        this.hotwordsList = res.hotwords || []
        this.searchHotwordsList = res.searchHotWords || []
      } catch (error) {
        console.log("获取搜索热词api报错=", error)
      }
    },

    async requestRecommendQueryFn () {
      try {
        const keyword = xss(this.searchWord)

        if (!keyword) return

        const { gradeId, switch_grade = -1, switch_subject = -1 } = this.$route.query
        const gradeIds = +gradeId || +jsCookie.get('userGrade') || 4
        const { data } = await axios.get('https://online.xueersi.com/mall/getQueryRecommend', {
          params: {
            devid: 1,
            type: 2,
            keyword,
            xesid: jsCookie.get('xesId'),
            gradeIds,
            switch_grade,
            switch_subject
          }
        })

        if (data && data.result && data.result.data && data.result.data.length > 0) {
          this.recommendQuery = data.result.data
        }
      } catch (error) {
        console.log('requestRecommendQuery==', error)
      }
    },

    onInputSearchFn () {
      clearTimeout(this.timer)
      const value = xss(this.$refs.searchInput.value).trim()
      if (value) {
        this.querySugList = ['正在加载中...']
        clearTimeout(this.timer)
        this.timer = setTimeout(async () => {
          try {
            const { data: res } = await axios.get('https://mall.xueersi.com/getQuerySug', {
              params: {
                keyword: value,
                xesid: jsCookie.get('xesId'),
                devid: 1,
                page_grade: jsCookie.get('userGrade') || 4
              }
            })
            if (res && res.length) {
              this.querySugList = res
            } else {
              this.querySugList = ['无搜索结果']
            }
          } catch (error) {
            console.log("获取搜索query词api报错=", error)
            this.querySugList = ['无搜索结果']
          }
        }, 1000)
      } else {
        this.querySugList = []
      }
    },

    formatQueryItemFn (item) {
      const value = xss(this.$refs.searchInput.value)
      const str = item.replace(`${ value }`, `<span style="color:#ff0021;">${ value }</span>`)
      return str
    },

    onInputFocusFn () {
      this.$nextTick(() => { this.inputIsFocus = true })
      this.getSearchHistoryFn()
    },

    onInputBlurFn () {
      setTimeout(() => { this.inputIsFocus = false }, 290)
    },

    clickSearchBtn () {
      if (!this.searchWord) return
      this.onEnterSearchFn()
    },

    onEnterSearchFn () {
      const keyword = xss(this.searchWord)
      this.toSearchPage(keyword)
    },

    toSearchPage(keyword) {
      this.saveSearchHistoryFn({keyword})
      window.open(`//online.xueersi.com/search?keyword=${keyword}`)
    },

    getSearchHistoryFn () {
      const words = jsCookie.get('search_history')
      if (words) {
        this.searchHistoryList = Base64.decode(words).split(',')
      }
    },

    saveSearchHistoryFn ({ keyword }) {
      let data = []
      const words = jsCookie.get('search_history')
      if (words) {
        data = data.concat(Base64.decode(words).split(','))
      }
      const i = data.indexOf(keyword)
      if (i >= 0) {
        data.splice(i, 1)
      }
      data.unshift(keyword)
      data = data.slice(0, 5)
      jsCookie.set('search_history', Base64.encode(data.join(',')), {
        expires: 7, domain: '.xueersi.com'
      })
    },

    clearHistoryFn () {
      jsCookie.remove('search_history', {
        domain: '.xueersi.com'
      })
      this.searchHistoryList = []
    },

    onLocationChangeFn (provinceId) {
      this.$emit('change', provinceId)
    },
  },
}
</script>

<style lang="scss" scoped>
.search__component {
  width: 100%;
  box-sizing: border-box;
  padding-top: 20px;
  background-color: #ffffff;
  position: relative;
  border-top: 1px solid #f8f8f8;

  .search__component-block {
    width: 1200px;
    margin: 0 auto;
    box-sizing: border-box;
    padding-left: 30px;
    display: flex;
    align-items: center;
  }

  .location__block {
    margin-right: 16px;
  }

  .search__block {
    width: 410px;
    box-sizing: border-box;
    height: 36px;
    border: 1px solid #e5e5e5;
    border-radius: 18px;
    padding: 0 13px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
  }

  .search__block.focused {
    border-radius: 16px 16px 0 0;
    border-bottom-color: transparent;
  }

  .search__input {
    height: 30px;
    padding: 0;
    border: none;
    flex: 1;
    color: #333333;
    outline: none;
  }

  .search__icon {
    width: 16px;
    background-image: url('./icon.png');
    height: 16px;
    background-size: cover;
    margin-left: 13px;
  }

  .search__words {
    position: absolute;
    right: 42px;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    justify-content: center;
    align-items: center;

    .item {
      box-sizing: border-box;
      height: 20px;
      line-height: 20px;
      cursor: pointer;
      border-radius: 10px;
      padding: 0px 11px;
      background-color: #FAFAFA;
      color: #999999;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
    }

    .item:hover {
      background-color: #000000;
      color: #ffffff;
    }

    .item + .item {
      margin-left: 10px;
    }
  }

  .search__list {
    width: 100%;
    position: absolute;
    left: -1px;
    top: 35px;
    z-index: 11;
    border-radius: 0 0 16px 16px;
    border: 1px solid #e5e5e5;
    background-color: #ffffff;
    transform-origin: 0 0;
    overflow: hidden;
    .search__list-block {
      width: 100%;
      box-sizing: border-box;
    }
  }

  .search__list .query__list {
    .query__item {
      cursor: pointer;
      padding: 0 20px;
      height: 36px;
      line-height: 36px;
      color: #afafaf;
      font-size: 12px;
      &:hover {
        background: #f5f5f5;
      }
    }
  }

  .search__hotwords {
    .title {
      height: 30px;
      line-height: 30px;
      padding: 10px 20px;
      color: #333333;
      font-size: 14px;
    }
    .item {
      cursor: pointer;
      height: 36px;
      line-height: 36px;
      padding: 0 20px;
      color: #afafaf;
      &:hover {
        background: #f5f5f5;
      }
      font-size: 12px;
    }
    .item .tag {
      display: inline-block;
      width: 20px;
      height: 20px;
      border-radius: 50%;
      color: #ffffff;
      text-align: center;
      line-height: 20px;
      margin-right: 5px;
      font-size: 14px;
    }
    .item .tag__1 {
      background-color: #f13132;
    }
    .item .tag__2 {
      background-color: #f0773d;
    }
    .item .tag__3 {
      background-color: #f6a724;
    }
    .item .tag__gray {
      background-color: #999999;
    }
  }

  .search__history {
    .history__header {
      padding: 10px 20px;
      height: 30px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .history__header .title {
      color: #333333;
      font-size: 14px;
    }
    .history__header .clear {
      cursor: pointer;
      font-size: 13px;
      color: #afafaf;
      &:hover {
        color: #f13232;
      }
    }
    .item {
      cursor: pointer;
      height: 36px;
      line-height: 36px;
      padding: 0 20px;
      color: #afafaf;
      &:hover {
        background: #f5f5f5;
      }
      font-size: 12px;
    }
  }

  .recommend-query{
    margin-left: 20px;
    &__word{
      display: inline-block;
      padding: 0 10px;
      margin-right: 10px;
      height: 20px;
      background-color: #FAFAFA;
      border-radius: 10px;
      line-height: 20px;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
      &:last-of-type{
        margin-right: 0px;
      }
    }
  }
}

.drop-enter-active, .drop-leave-active {
  transition: .3s;
}
.drop-enter, .drop-leave-to {
  transform: scaleY(0);
}
</style>



// WEBPACK FOOTER //
// ./src/components/xesMallSearch/search.vue